export const validationConstants = {
  emailRegex: /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
  numberRegex: /^\d*\.?\d+$/
};
